/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { GetLibraryHighlightsEffects } from 'app/library/store/effects/get-library-highlights.effect';
import { GetLibraryGamesEffects } from 'app/library/store/effects/get-library-games.effect';
import { GetLibraryUploadedGamesEffects } from 'app/library/store/effects/get-library-uploaded-games.effect';
import { GetLibraryClipsEffects } from 'app/library/store/effects/get-library-clips.effect';
import { GetLibraryProFeedbackEffects } from 'app/library/store/effects/get-library-pro-feedback.effect';
import { SubmitHighlightFormEffects } from 'app/library/store/effects/submit-highlight-form.effect';
import { GetBreakdownQueueEffects } from 'app/library/store/effects/get-breakdown-queue.effect';

export const effects: any[] = [
  GetLibraryHighlightsEffects,
  GetLibraryGamesEffects,
  GetLibraryUploadedGamesEffects,
  GetLibraryClipsEffects,
  GetLibraryProFeedbackEffects,
  SubmitHighlightFormEffects,
  GetBreakdownQueueEffects,
];

export * from 'app/library/store/effects/get-library-highlights.effect';
export * from 'app/library/store/effects/get-library-games.effect';
export * from 'app/library/store/effects/get-library-uploaded-games.effect';
export * from 'app/library/store/effects/get-library-clips.effect';
export * from 'app/library/store/effects/get-library-pro-feedback.effect';
export * from 'app/library/store/effects/submit-highlight-form.effect';
export * from 'app/library/store/effects/get-breakdown-queue.effect';
